<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
      <LatestAnalysis :data="data">
        <div class="flex-1 d-flex items-center gap-2  text-[16px]">
          <router-link :to="{name: 'GeoReputationReputation', params: $route.params, query: $route.query}" class="back d-flex gap-2 font-bold">
            <img src="@/assets/img/IAReputation/BackGeo.svg" />
            <span class="text-purple">{{ brandName }}</span>
          </router-link>
          <span>{{ data?.site?.name }}</span>
          <span>{{ data?.site?.location_full_address }}</span>
        </div>
      </LatestAnalysis>
      <div class="tabs"  :class="{'isPromptsTab': tabActive === 'Prompts'}">
        <button @click="tabActive = 'Reputation'" :class="{'active': tabActive === 'Reputation'}">{{ $gettext('Reputation') }}</button>
        <button @click="tabActive = 'Visibility'" :class="{'active': tabActive === 'Visibility'}">{{ $gettext('Visibility') }}</button>
        <button @click="tabActive = 'Gaia'" :class="{'active': tabActive === 'Gaia'}">{{ $gettext('Google AI Alignment') }}</button>
        <button @click="tabActive = 'Topics'" :class="{'active': tabActive === 'Topics'}">{{ $gettext('Topics') }}</button>
        <button @click="tabActive = 'Sources'" :class="{'active': tabActive === 'Sources'}">{{ $gettext('Sources') }}</button>
        <button @click="tabActive = 'Prompts'" :class="{'active': tabActive === 'Prompts'}">{{ $gettext('GeoPrompts') }}</button>
      </div>
      <component :is="viewActive"
                 :geoData="data"
                 :site_uuid="tabActive === 'Prompts' ? $route.query.site_uuid : null"

      ></component>
    </div>
  </div>
</template>

<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysisGeo.vue";
import SkeletonCard from "@/components/common/skeletonCard.vue";
import MixinIAReputation from "@/mixins/iareputation";
//importo componentes de vistas
import ViewReputation from '@/components/IAReputation/Views/Reputation.vue'
import ViewVisibility from '@/components/IAReputation/Views/Visibility.vue'
import ViewGaia from '@/components/IAReputation/Views/Gaia.vue'
import ViewTopics from '@/components/IAReputation/Views/Topics.vue'
import ViewSources from '@/components/IAReputation/Views/Sources.vue'
import ListPrompts from "@/components/IAReputation/ListPrompts.vue"
import SrvIAReputationService from "@/services/iareputation.js"

export default {
  components: { LatestAnalysis, SkeletonCard, ViewReputation, ViewVisibility, ViewTopics, ViewSources, ViewGaia, ListPrompts },
  mixins: [MixinIAReputation],
  data() {
    return {
      data: null,
      loading: false,
      itemActive: null,
      tabActive: 'Reputation',
      notAnalysis: null,
    }
  },
  computed: {
    viewActive() {
      if (this.tabActive === 'Reputation') return ViewReputation
      if (this.tabActive === 'Visibility') return ViewVisibility
      if (this.tabActive === 'Gaia') return ViewGaia
      if (this.tabActive === 'Topics') return ViewTopics
      if (this.tabActive === 'Sources') return ViewSources
      if (this.tabActive === 'Prompts') return ListPrompts
      return ''
    }
  },
  methods: {
    async getData () {
      try {
        if (!this.brandUUID) {
          this.notAnalysis = true
          return false
        }
        this.loading = true
        const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID, site_uuid: this.$route.query.site_uuid})
        if (status === 200) {
          this.data = data
          this.notAnalysis = !data.created_at
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    brandUUID() {
      this.$router.push({ name: 'GeoReputation' })
    }
  }
}


</script>
<style scoped>
.back{
  text-decoration: none;
}
.tabs{
  padding: 0px 20px;
  margin: 0 -20px 0 -25px;
  display: flex;
  background-color: #fff;
  gap: 1rem;
  font-size: 14px;
  button{
    padding: 0 10px;
    padding-bottom: 5px;
    &.active, &:hover {
      font-weight: bold;
      border-bottom: 2px solid red;

    }
  }

}
.isPromptsTab{
  margin-bottom: 10px;
}
</style>
